import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  IonAvatar,
  IonIcon,
  IonItem,
  IonLabel,
  IonText,
  MenuController,
  ModalController,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { logInOutline, personCircle } from 'ionicons/icons';

import { AuthenticationService } from '../../../services/authentication.service';
import { LoginPageComponent } from '../../pages/login-page/login-page.component';
import { SignupPageComponent } from '../../pages/signup-page/signup-page.component';

@Component({
  selector: 'cmn-user-login-list-item',
  templateUrl: './user-login-list-item.component.html',
  styleUrls: ['./user-login-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, IonItem, IonAvatar, IonIcon, IonLabel, IonText],
})
export class UserLoginListItemComponent {
  private readonly authenticationService = inject(AuthenticationService);
  public readonly user = this.authenticationService.user;
  private readonly menuController = inject(MenuController);
  private readonly modalController = inject(ModalController);

  constructor() {
    addIcons({ personCircle, logInOutline });
  }

  async openLoginModal(): Promise<void> {
    this.menuController.close();
    const loginPage = await this.modalController.create({
      component: LoginPageComponent,
    });
    await loginPage.present();

    const { data } = await loginPage.onDidDismiss();
    if (data === 1) {
      const signupPage = await this.modalController.create({
        component: SignupPageComponent,
      });
      await signupPage.present();
      await signupPage.onDidDismiss();
    }
  }
}
